<template>
  <div>
    <div class="top-bar flex justify-end">
      <v-button v-if="!create"
        @click="addRow"
        icon="plus"
      >{{ $t('add_generic') }}</v-button>
      <v-button v-if="create"
        @click="addRow"
        icon="ban"
        color="red"
      >{{ $t('cancel') }}</v-button>
      
    </div>

    <div>
       
      <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeInUp"
        leave-active-class="animated fadeOutDown"
      >
        <div class="panel">

          <!-- form create new -->
          <div class="w-full flex flex-wrap" v-show="create!=false || form.code">
            <div class="panel">
              <!-- label que diga add field -->
              <label class="w-full text-center text-lg font-bold">
                {{ $t('add_field') }}
              </label>
              <form @submit.prevent="changeRow" class="w-full flex">
                <div class="flex-grow pr-3">
                  <label for="code" class="w-full">{{ $t('code') }}</label>
                  <v-input
                    v-model="form.code"
                    title="code"
                    id="code"
                    name="code"
                    placeholder="place_placeholder"
                    class="w-full"
                    required
                  />
                </div>
                <div class="flex-grow pr-3">
                  <label for="name" class="w-full">{{ $t('name') }}</label>
                  <v-input
                    v-model="form.name"
                    title="name"
                    id="name"
                    name="name"
                    placeholder="name"
                    class="w-full"
                    required
                  />
                </div>
                <div class="flex-grow pr-3">
                  <label for="order" class="w-full">{{ $t('order') }}</label>
                  <v-input
                    v-model="form.order_column"
                    title="order"
                    id="order"
                    name="order"
                    placeholder="order"
                    class="w-full"
                    required
                    type="number"
                  />
                </div>

                <div class="flex-grow pr-3">
                  <label for="load_projects" class="w-full">{{ $t('load_projects') }}</label>
                  <b-switch
                    v-model="form.load_projects"
                    :title="$t('load_projects')"
                    id="load_projects"
                    name="load_projects"
                    class="w-full"
                  />
                </div>
                <div class="flex-grow-0 pr-3 inline-flex self-end">
                  <v-button
                    native-type="submit"
                    :disabled="!form.code && !form.name && !form.order_column"
                  >{{ $t('save') }}</v-button>
                </div>
              </form>
            </div>
          </div>

          <!-- add issuefielValues -->
          <div class="w-full flex flex-wrap" v-show="isAddValue">
            <div class="panel">
              <!-- label que diga add field -->
              <label class="w-full text-center text-lg font-bold">
                {{ $t('add_value_to') }} {{ addValueFieldName }}
              </label>
              <form class="w-full flex"
                @submit.prevent="saveIssuefielValue"
              >
                <div class="flex-grow pr-3">
                  <label for="id" class="w-full">{{ $t('code') }}</label>
                  <b-input
                    v-model="formIssuefieldValue.code"
                    title="code"
                    id="code"
                    name="code"
                    placeholder="code"
                    class="w-full"
                    required
                  />
                </div>
                <div class="flex-grow pr-3">
                  <label for="name" class="w-full">{{ $t('name') }}</label>
                  <b-input
                    v-model="formIssuefieldValue.name"
                    title="name"
                    id="name"
                    name="name"
                    placeholder="name"
                    class="w-full"
                    required 
                  />
                </div>
                <div class="flex-grow pr-3">
                  <label for="order_column" class="w-full">{{ $t('order') }}</label>
                  <b-input
                    v-model="formIssuefieldValue.order_column"
                    title="order"
                    id="order_column"
                    name="order_column"
                    placeholder="order"
                    class="w-full"
                    required
                    type="number"
                  />
                </div>
                <div class="flex-grow-0 pr-3 inline-flex self-end">
                      <v-button
                      native-type="submit"
                      :disabled="!formIssuefieldValue.name && !formIssuefieldValue.code && !formIssuefieldValue.order_column"
                      >{{ $t('save') }}</v-button>
                </div>
              </form>
            </div>
          </div>

          <section>
            <b-table
              show-empty
              icon-pack="fas"
              :data="data"
              :loading="isLoading"
              paginated
              :per-page="perPage"
              :total="total"
              @page-change="onPageChange"
              backend-sorting
              :default-sort="orderField"
              :default-sort-direction="orderDir"
              @sort="onSort"
              striped
              bordered
              detailed
            >
              <template v-slot:empty="">
                <h4>{{ $t('no_rows') }}</h4>
              </template>

              <template>
                <b-table-column field="code" sortable width="200">
                  <template v-slot:header="">
                    {{ $t('code') }}
                  </template>
                  <template v-slot="props">
                    <div v-if="newData && newData.id == props.row.id">
                      <v-input
                        v-model="newData.code"
                        title="code"
                        id="code"
                        name="code"
                        :value="props.row.code"
                        placeholder="code"
                        class="w-full"
                        :ref="'fieldName' + props.row.id"
                      />
                    </div>
                    <div v-else>
                      {{ props.row.code }}
                    </div>
                  </template>
                </b-table-column>

                <b-table-column field="name" >
                  <template v-slot:header="">
                    {{ $t('name') }}
                  </template>
                  <template v-slot="props">
                    <div v-if="newData && newData.id == props.row.id">
                      <v-input
                        v-model="newData.name"
                        title="name"
                        id="name"
                        name="name"
                        :value="props.row.name"
                        placeholder="name"
                        class="w-full"
                        :ref="'fieldName' + props.row.id"
                      />
                    </div>
                    <div v-else>
                      {{ props.row.name }}
                    </div>
                  </template>
                </b-table-column>

                <b-table-column field="order" >
                  <template v-slot:header="">
                    {{ $t('order') }}
                  </template>
                  <template v-slot="props">
                    <div v-if="newData && newData.id == props.row.id">
                      <v-input
                        v-model="newData.order_column"
                        title="order"
                        id="order"
                        name="order"
                        :value="props.row.order_column"
                        placeholder="order"
                        class="w-full"
                        :ref="'fieldName' + props.row.id"
                        type="number"
                      />
                    </div>
                    <div v-else>
                      {{ props.row.order_column }}
                    </div>
                  </template>
                </b-table-column>
 
                <b-table-column field="actions" centered width="120">
                  <template v-slot:header="">
                    {{ $t('actions') }}
                  </template>
                  <template v-slot="props"> 
                    <div class="w-full h-full flex items-center justify-around">
                      <div v-if="newData && newData.id == props.row.id">
                        <b-tooltip :label="$t('save')" position="is-left">
                          <div @click="saveIssuefield()" class="cursor-pointer flex text-blue">
                            <b-icon pack="fas" icon="save" />
                          </div>
                        </b-tooltip>
                        <b-tooltip
                          :label="$t('cancel')"
                          type="is-danger"
                          position="is-left"
                        >
                          <div @click="() => { newData = {} }" class="cursor-pointer flex text-red">
                            <b-icon pack="fas" icon="ban" />
                          </div>
                        </b-tooltip>
                      </div>

                      <div v-else>
                        <b-tooltip
                          v-if="create && parent_id == props.row.id"
                          :label="$t('cancel')"
                          position="is-left"
                        >
                          <div @click="addRow()" class="cursor-pointer flex text-red">
                            <b-icon pack="fas" icon="ban" />
                          </div>
                        </b-tooltip>
                        <b-tooltip
                          v-if="props.row.load_projects"
                          :label="$t('synchronize_projects')"
                          position="is-left"
                        >
                          <div @click="synchronizeProjects(props.row.id)" class="cursor-pointer flex text-blue">
                            <b-icon pack="fas" icon="sync-alt" />
                          </div>
                        </b-tooltip>
                        <b-tooltip
                          v-if="addValueFieldId != props.row.id"
                          :label="$t('add_value_to') + ' ' + props.row.name"
                          position="is-left"
                        >
                          <div @click="addValue(props.row)" class="cursor-pointer flex text-blue">
                            <b-icon pack="fas" icon="plus" />
                          </div>
                        </b-tooltip>
                        <!-- cancel add value -->
                        <b-tooltip
                          v-if="isAddValue && addValueFieldId == props.row.id"
                          :label="$t('cancel')"
                          position="is-left" 
                        >
                          <div @click="addValue(props.row)" class="cursor-pointer flex text-red">
                            <b-icon pack="fas" icon="ban" />
                          </div>
                        </b-tooltip>
                        <b-tooltip :label="$t('edit')" position="is-left">
                          <div @click="editRow(props.row)" class="cursor-pointer flex text-blue">
                            <b-icon pack="fas" icon="pencil-alt" />
                          </div>
                        </b-tooltip>

                        <b-tooltip
                          v-if="false"
                          :label="$t('used')"
                          position="is-left"
                        >
                          <div class="cursor-not-allowed flex text-grey">
                            <b-icon pack="fas" icon="trash-alt" />
                          </div>
                        </b-tooltip>

                        <b-tooltip
                          v-else
                          :label="$t('delete')"
                          type="is-danger"
                          position="is-left"
                        >
                          <div @click="removeRow(props.row)" class="cursor-pointer flex text-red">
                            <b-icon pack="fas" icon="trash-alt" />
                          </div>
                        </b-tooltip>
                      </div>

                    </div>
                  </template>
                </b-table-column>

              </template>
              <template slot="detail" slot-scope="props">
                <div class="mb-1" v-if="props.row">
                  <b-collapse
                  class="card"
                  animation="slide"
                  aria-id="content"
                  >
                  <template #trigger="prop">
                    <div
                    class="card-header"
                    role="button"
                    aria-controls="content"
                    :aria-expanded="prop.open"
                    >
                      <div class="card-header-title">
                        <h4>
                          <b> {{  props.row.values.length }} {{ $t('values') }}
                          </b>
                        </h4>
                      </div>
                    </div>
                  </template>
                  <div class="card-content p-0">
                    <div class="content">
                      <template v-if="props.row.values.length > 0">
                        <b-table
                          show-empty
                          icon-pack="fas"
                          :data="props.row.values"
                          :loading="isLoading"
                          :default-sort="orderField"
                          :default-sort-direction="orderDir"
                          striped
                          bordered
                        >
                        <template>
                          <b-table-column field="code" label="P" cell-class="w-8 vertical-center" centered sortable>
                            <template v-slot:header="">
                              {{ $t('code') }}
                            </template>
                            <template v-slot="props">
                              <div v-if="newDataValue && newDataValue.id == props.row.id">
                                <v-input
                                  v-model="newDataValue.code"
                                  title="code"
                                  id="code"
                                  name="code"
                                  :value="props.row.code"
                                  placeholder="code"
                                  class="w-full"
                                  :ref="'fieldCode' + props.row.id"
                                />
                              </div>
                              <div v-else>
                                {{ props.row.code }}
                              </div>
                            </template>
                          </b-table-column>
                          <b-table-column field="name" label="Nombre" cell-class="w-8 vertical-center" centered sortable>
                            <template v-slot:header="">
                              {{ $t('name') }}
                            </template>
                            <template v-slot="props">
                              <div v-if="newDataValue && newDataValue.id == props.row.id">
                                <v-input
                                  v-model="newDataValue.name"
                                  title="name"
                                  id="name"
                                  name="name"
                                  :value="props.row.name"
                                  placeholder="name"
                                  class="w-full"
                                  :ref="'fieldCode' + props.row.id"
                                />
                              </div>
                              <div v-else>
                                {{ props.row.name }}
                              </div>
                            </template>
                          </b-table-column>
                          <b-table-column field="order_column" label="order" cell-class="w-8 vertical-center" centered sortable>
                            <template v-slot:header="">
                              {{ $t('order') }}
                            </template>
                            <template v-slot="props">
                              <div v-if="newDataValue && newDataValue.id == props.row.id">
                                <v-input
                                  v-model="newDataValue.order_column"
                                  title="order"
                                  id="order"
                                  name="order"
                                  :value="props.row.order_column"
                                  placeholder="order"
                                  class="w-full"
                                  type="number"
                                  :ref="'fieldCode' + props.row.id"
                                />
                              </div>
                              <div v-else>
                                {{ props.row.order_column }}
                              </div>
                            </template>
                          </b-table-column>
                          <b-table-column field="actionsClid" centered width="120">
                            <template v-slot:header="">
                              {{ $t('actions') }}
                            </template>
                            <template v-slot="props">
                              <div v-if="newDataValue && newDataValue.id == props.row.id">
                                <b-tooltip :label="$t('save')" position="is-left">
                                  <div @click="saveIssuefieldValue()" class="cursor-pointer flex text-blue">
                                    <b-icon pack="fas" icon="save" />
                                  </div>
                                </b-tooltip>
                                <b-tooltip
                                  :label="$t('cancel')"
                                  type="is-danger"
                                  position="is-left"
                                >
                                  <div @click="() => { newDataValue = {} }" class="cursor-pointer flex text-red">
                                    <b-icon pack="fas" icon="ban" />
                                  </div>
                                </b-tooltip>
                              </div>

                              <div v-else
                               class="w-full h-full flex items-center justify-around">
                                <b-tooltip :label="$t('edit')" position="is-left">
                                  <div @click="editRowValue(props.row)" class="cursor-pointer flex text-blue">
                                    <b-icon pack="fas" icon="pencil-alt" />
                                  </div>
                                </b-tooltip>
                                <b-tooltip
                                  v-if="false"
                                  :label="$t('used')"
                                  position="is-left"
                                >
                                  <div class="cursor-not-allowed flex text-grey">
                                    <b-icon pack="fas" icon="trash-alt" />
                                  </div>
                                </b-tooltip>
                                <b-tooltip
                                  v-else
                                  :label="$t('delete')"
                                  type="is-danger"
                                  position="is-left"
                                >
                                  <div @click="removeRowValue(props.row)" class="cursor-pointer flex text-red">
                                    <b-icon pack="fas" icon="trash-alt" />
                                  </div>
                                </b-tooltip>
                              </div>
                            </template>
                          </b-table-column>

                        </template>

                        </b-table>
                      </template>
                    </div>
                  </div>
                  </b-collapse>
                </div>
              </template>
            </b-table>
          </section>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>

import axios from "axios";
import {mapGetters} from "vuex";
export default {
  name: "issue-codification",

  data: () => ({
    data: [],
    form: {
      code: "",
      name: "",
      order_column: "",
      load_projects: false
    },
    formIssuefieldValue: {
      name: null,
      code: null,
      order_column: null
    },
    project: {},
    isAddValue: false,
    addValueFieldId: null,
    addValueFieldName: null,
    parent_id: null,

    newData: {},
    newDataValue: {},
    create: false,
    isLoading: true,
    page: 1,
    perPage: 15,
    total: 0,
    orderField: "name",
    orderDir: "asc",







  }),
  computed: {
      ...mapGetters({
        company: "app/company"
      }),
  },


  mounted() {
    this.getIssuefields();      
  },

  methods: {
    async addRow() {

      if (this.create) {
        this.create = false;
        this.form.code = "";
        this.form.name = "";
        this.form.order_column = "";
        this.form.load_projects = false;
      } else {
        this.create = true;
      }
    },
    addValue(row) {
      this.isAddValue = !this.isAddValue;
      if (this.isAddValue) {
        this.addValueFieldId = row.id;
        this.addValueFieldName = row.name;
      } else {
        this.addValueFieldId = null;
        this.addValueFieldName = null;
      }
    },
    async getIssuefields() {
      this.isLoading = true;
      let params = {
        // order_dir: this.orderDir,
        // order_field: this.orderField,
        // entity_type: this.entity_type, // en este momento no usado en backend
      };

      
      const { data } = await axios.get(
        "/api/v2/company/" + this.company.id + "/issuefields",
        { params: params }
      );
      if (data && data.success) {
        this.data = data.issuefields;
        this.total = data.data ? data.data.length : 0;
      } else {
        this.$notify.error("error_loading_data");
      }
      this.isLoading = false;
    },

    saveIssuefielValue() {
      
      const url = "/api/v2/company/" + this.company.id + "/issuefield/" + this.addValueFieldId + "/value";
      const data = {
          name: this.formIssuefieldValue.name,
          code: this.formIssuefieldValue.code,
          order_column: this.formIssuefieldValue.order_column
        };
      axios.post(url, data).then(response => {

        if (response.data.success) {
          this.$notify.success("saved");
        } else {
          this.$notify.error("error_saving");
        }
      }).catch(error => {
        this.$notify.error("error_saving");
        console.log(error);
      }).finally(() => {
        
        this.formIssuefieldValue = {
          
          name: null,
          code: null,
          order_column: null
        };

        this.reload();

      });
    },

    reload() {
      this.getIssuefields();
      
    },

    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },

    onPageChange(page) {
      this.page = page;
      this.reload();
    },

    onSort(field, order) {
      this.orderField = field;
      this.orderDir = order;
      this.reload();
    },

    editRow(row) {
      this.newData = row
      this.$nextTick(() => {
        let refName = `fieldName${row.id}`
        this.$refs[refName].$el.focus()
      });
    },

    editRowValue(row) {
      this.newDataValue = row
      this.$nextTick(() => {
        let refName = `fieldCode${row.id}`
        this.$refs[refName].$el.focus()
      });
    },

    async saveIssuefield() {
      if (this.newData.code == '') {
        this.$notify.error(this.$t('empty_field_required', ['code']))
        return
      }

      if (this.newData.name == '') {
        this.$notify.error(this.$t('empty_field_required', ['nombre']))
        return
      }

      if (this.newData.order_column == '') {
        this.$notify.error(this.$t('empty_field_required', ['order']))
        return
      }

      const { data } = await axios.post("/api/v2/issuefield/" + this.newData.id, {
        code: this.newData.code,
        name: this.newData.name,
        order_column: this.newData.order_column,
      })

      if (data && data.success) {
        
        let index = this.data.findIndex(x => x.id === this.newData.id);
        if( index !== -1 )
          this.data[index] = this.newData
        // else // en este caso se añadiria al array
        this.newData = {}

        this.$notify.success('success_editing')

      } else if(data && data.msg) {
        this.$notify.error('no_access_permissions')
      } else {
        this.$notify.error('error_saving')
      }
    },

    async saveIssuefieldValue() {
      if (this.newDataValue.code == '') {
        this.$notify.error(this.$t('empty_field_required', ['code']))
        return
      }

      if (this.newDataValue.name == '') {
        this.$notify.error(this.$t('empty_field_required', ['nombre']))
        return
      }

      if (this.newDataValue.order_column == '') {
        this.$notify.error(this.$t('empty_field_required', ['order']))
        return
      }

      const { data } = await axios.post("/api/v2/issuefield-value/" + this.newDataValue.id, {
        code: this.newDataValue.code,
        name: this.newDataValue.name,
        order_column: this.newDataValue.order_column,
      })

      if (data && data.success) {
        
        let index = this.data.findIndex(x => x.id === this.newDataValue.id);
        if( index !== -1 )
          this.data[index] = this.newDataValue
        // else // en este caso se añadiria al array
        this.newDataValue = {}

        this.$notify.success('success_editing')

      } else if(data && data.msg) {
        this.$notify.error('no_access_permissions')
      } else {
        this.$notify.error('error_saving')
      }
    },

    async removeRow(row) {
      this.$dialog.confirm({
        title: this.$t("delete"),
        message: this.$t("delete_confirm_text", ['('+row.code+')', row.name]),
        confirmText: this.$t("delete"),
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          this.isLoading = true;
          let url = "/api/v2/issuefield/" + row.id;
          const { data } = await axios.delete(url);

          if (data.success) {
            this.$toast.open({
              message: this.$t("removed_successfully"),
              type: "is-success",
              position: "is-top-right"
            });

            await this.sleep(1000);
            this.isLoading = false;

            this.reload();
          } else {
            this.isLoading = false;
            // Error
            this.$toast.open({
              message: data.error || this.$t("remove_error"),
              type: "is-danger",
              position: "is-top-right"
            });
          }
        }
      });
    },

    async removeRowValue(row){
      this.$dialog.confirm({
        title: this.$t("delete"),
        message: this.$t("delete_confirm_text", ['('+row.code+')', row.name]),
        confirmText: this.$t("delete"),
        type: "is-danger",
        hasIcon: true,
        onConfirm: async () => {
          this.isLoading = true;
          let url = "/api/v2/issuefield-value/" + row.id;
          const { data } = await axios.delete(url);

          if (data.success) {
            this.$toast.open({
              message: this.$t("removed_successfully"),
              type: "is-success",
              position: "is-top-right"
            });

            await this.sleep(1000);
            this.isLoading = false;

            this.reload();
          } else {
            this.isLoading = false;
            // Error
            this.$toast.open({
              message: data.error || this.$t("remove_error"),
              type: "is-danger",
              position: "is-top-right"
            });
          }
        }
      });
    },

    async changeRow() {
      this.isLoading = true;

      let params = {
        code: this.form.code,
        name: this.form.name,
        order_column: this.form.order_column,
        load_projects: this.form.load_projects
      };

      let url = "/api/v2/company/" + this.company.id + "/issuefields";
      axios({
        method: "post",
        url: url,
        data: params
      })
        .then(response => {
          this.$toast.open({
            message: this.$t("save_successful"),
            type: "is-success",
            position: "is-top-right"
          });

          this.create = false;
          this.form.code = "";
          this.form.name = "";
          this.form.order_column = "";
          this.form.load_projects = false;
          this.reload();
        })
        .catch(error => {
          //Se produjo un error
          this.isLoading = false;
          if (error.response && error.response.status === 422) {
            //extraemos el primer error de validación
            error.error_msg =
              error.response.data.errors[
                Object.keys(error.response.data.errors)[0]
              ][0];
          }

          // Mostramos el error
          this.$toast.open({
            message: error.error_msg || this.$t("error_saving"),
            type: "is-danger",
            position: "is-top-right"
          });
        });
    },

    async synchronizeProjects(issuefield_id) {
      // this function is used to synchronize projects with the issue field values
      try{
        this.isLoading = true;
        let url = "/api/v2/issuefield/" + issuefield_id + "/synchronize-projects";
        const { data } = await axios.post(url);
        if (data.success) {
          this.$toast.open({
            message: this.$t("assignment_update_success"),
            type: "is-success",
            position: "is-top-right"
          });
        } else {
          this.$toast.open({
            message: data.error || this.$t("assignment_update_error"),
            type: "is-danger",
            position: "is-top-right"
          });
        }

      } catch (error) {
        this.isLoading = false;
        this.$notify.error(this.$t("assignment_update_error"));
      } finally {
        this.isLoading = false;
        this.reload();
      }
      
    }

  }
};
</script>
